exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DrawerIframe-local__iframe--yhF8r {\n  width: 100%;\n  height: 100vh;\n  z-index: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: none;\n  padding: 2rem 5rem 2rem 1rem;\n  background-color: #fcfcfc; }\n", ""]);

// exports
exports.locals = {
	"iframe": "DrawerIframe-local__iframe--yhF8r"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/portal/portal/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src","node_modules/slick-carousel/slick"]}!./src/components/Community/NewCommunity/DrawerIframe/DrawerIframe.local.scss
// module id = 602
// module chunks = 0